/**
 * Product Comparison Grid — oddit-section-product-comparison-grid
 * Handles mobile horizontal scroll progress bar
 */
(function () {
  var SECTION_SELECTOR = '.oddit-section-product-comparison-grid';

  function initSwitchers(section) {
    section.querySelectorAll('[data-comparison-card]').forEach(function (card) {
      var details = card.querySelector('[data-card-switcher]');
      if (!details) return;

      var titleEl = card.querySelector('[data-card-title]');
      var priceEl = card.querySelector('[data-card-price]');
      var imageLink = card.querySelector('[data-card-image-link]');
      var imageEl = imageLink ? imageLink.querySelector('img') : null;
      var descEl = card.querySelector('[data-card-description]');
      var bestForEl = card.querySelector('[data-card-best-for]');
      var bestForLabelEl = card.querySelector('[data-card-best-for-label]');
      var sizesLabelEl = card.querySelector('[data-card-sizes-label]');
      var sizesTextEl = card.querySelector('[data-card-sizes-text]');
      var descDividerEl = card.querySelector('[data-card-divider-description]');
      var bestForDividerEl = card.querySelector('[data-card-divider-best-for]');
      var sizesDividerEl = card.querySelector('[data-card-divider-sizes]');

      details.querySelectorAll('[data-switcher-option]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var image = btn.getAttribute('data-switcher-image');
          var title = btn.getAttribute('data-switcher-title');
          var price = btn.getAttribute('data-switcher-price');
          var link = btn.getAttribute('data-switcher-link');
          var tagline = btn.getAttribute('data-switcher-tagline') || '';
          var bestFor = btn.getAttribute('data-switcher-best-for') || '';
          var sizesLabel = btn.getAttribute('data-switcher-sizes-label') || '';
          var sizesText = btn.getAttribute('data-switcher-sizes-text') || '';

          if (titleEl && title) titleEl.textContent = title;
          if (priceEl && price) priceEl.textContent = price;
          if (imageLink && link) imageLink.setAttribute('href', link);
          if (imageEl && image) {
            imageEl.removeAttribute('srcset');
            imageEl.setAttribute('src', image);
          }
          if (descEl) descEl.textContent = tagline;
          if (bestForEl) bestForEl.textContent = bestFor;
          if (bestForLabelEl) {
            if (bestFor) {
              bestForLabelEl.removeAttribute('hidden');
            } else {
              bestForLabelEl.setAttribute('hidden', '');
            }
          }
          if (sizesLabelEl) sizesLabelEl.textContent = sizesLabel;
          if (sizesTextEl) sizesTextEl.textContent = sizesText;

          if (descDividerEl) descDividerEl.style.display = tagline ? '' : 'none';
          if (bestForDividerEl) bestForDividerEl.style.display = bestFor ? '' : 'none';
          if (sizesDividerEl) sizesDividerEl.style.display = sizesText ? '' : 'none';

          details.open = false;
        });
      });
    });

    document.addEventListener('click', function (e) {
      section.querySelectorAll('[data-card-switcher][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.open = false;
      });
    });
  }

  function initSection(section) {
    initSwitchers(section);

    var scrollContainer = section.querySelector(
      '.oddit-section-product-comparison-grid__cards-wrapper'
    );
    var progressFill = section.querySelector(
      '.oddit-section-product-comparison-grid__progress-fill'
    );

    if (!scrollContainer || !progressFill) return;

    function updateProgress() {
      var scrollWidth = scrollContainer.scrollWidth;
      var clientWidth = scrollContainer.clientWidth;
      var scrollLeft = scrollContainer.scrollLeft;

      if (scrollWidth <= clientWidth) {
        progressFill.style.width = '100%';
        progressFill.style.left = '0';
        return;
      }

      var trackWidth = progressFill.parentElement.offsetWidth;
      var thumbRatio = clientWidth / scrollWidth;
      var thumbWidth = Math.max(thumbRatio * trackWidth, 20);
      var maxThumbLeft = trackWidth - thumbWidth;
      var maxScroll = scrollWidth - clientWidth;
      var thumbLeft = (scrollLeft / maxScroll) * maxThumbLeft;

      progressFill.style.width = thumbWidth + 'px';
      progressFill.style.left = thumbLeft + 'px';
    }

    scrollContainer.addEventListener('scroll', updateProgress, { passive: true });

    // Initial update
    updateProgress();

    // Re-check on resize in case scroll area changes
    var ro = new ResizeObserver(function () {
      updateProgress();
    });
    ro.observe(scrollContainer);

    // Store cleanup references
    section._odditComparisonCleanup = function () {
      scrollContainer.removeEventListener('scroll', updateProgress);
      ro.disconnect();
    };
  }

  function destroySection(section) {
    if (section && section._odditComparisonCleanup) {
      section._odditComparisonCleanup();
      delete section._odditComparisonCleanup;
    }
  }

  // Init all instances on page
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();